// @ts-ignore
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { ToastContainer } from "react-toastify";
import "./index.css";
import { client } from "./apollo";
import { AppRoutes } from "./routes";
import reportWebVitals from "./reportWebVitals";
// import { usePullToRefresh } from "./hooks/usePullToRefresh";
import { OfflineNotification } from "./utils/OfflineNotification";
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

function Root() {
  // usePullToRefresh();
  
  return (
    <ApolloProvider client={client}>
      <OfflineNotification />
      <ToastContainer />
      <div className="w-screen bg-black-responsive">
        <div
          className={`
            w-full 
            mx-auto 
            gradient-bg
            h-screen
            overflow-y-auto
            max-w-full
            sm:max-w-[450px]
            md:max-w-[450px]
            lg:max-w-[450px]
            xl:max-w-[450px]
          `}
        >
          <div className="w-full">
            <AppRoutes />
          </div>
        </div>
      </div>
    </ApolloProvider>
  );
}

root.render(<Root />);

reportWebVitals();